export const getAllLensRateMasterReducer = (
  state = { lensrate: [] },
  action
) => {
  switch (action.type) {
    case "GET_LENSRATE_SUCCESS":
      return {
        loading: false,
        lensrate: action.payload,
      };
    default:
      return state;
  }
};

export const getAllLensRateNamesReducer = (
  state = { lensrate_names: [] },
  action
) => {
  switch (action.type) {
    case "GET_LRNAME_SUCCESS":
      return {
        lensrate_names: action.payload,
      };
    default:
      return state;
  }
};
